module.exports = __webpack_public_path__ + "img/newLogo.baff78ce.png";